import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as QueriesQL from "queries/blog-collection";

export const Sidebar = () => null;
export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: { siteId, collectionId },
  },
}) => {
  const {
    values,
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the collection <b>{values.title}</b>? The posts in it stay
            exactly where they are; a page showing it will say it is gone.
          </Col>
        </Row>
        <Mutation
          mutation={QueriesQL.remove}
          update={QueriesQL.update()}
          onMutate={({ handler }) => {
            handler({
              variables: { siteId, collectionId },
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
